module.exports = __webpack_public_path__ + "img/offers5.51b60c19.jpg";